import { render, staticRenderFns } from "./handelRefundDialog.vue?vue&type=template&id=2bc94728&scoped=true"
import script from "./handelRefundDialog.vue?vue&type=script&lang=js"
export * from "./handelRefundDialog.vue?vue&type=script&lang=js"
import style0 from "./handelRefundDialog.vue?vue&type=style&index=0&id=2bc94728&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc94728",
  null
  
)

export default component.exports